<template>
<standard-dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{ $t('gateway.add_gateway')}}</span>
  </template>

  <v-form v-model="valid" ref="form" lazy-validation v-on:submit.prevent="submit">
    <v-text-field box :error-messages="errors" mask="NNNNNN" v-model="authCode" :disabled="loading" :rules="authCodeRules" :label="$t('gateway.auth_code')" autofocus></v-text-field>
  </v-form>

  <template slot="actions">
    <v-spacer></v-spacer>
    <v-btn flat color="primary" :loading="loading" :disabled="!valid" @click="submit">{{ $t('gateway.add') }}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'

export default {
  name: 'GatewayAuthCode',
  mixins: [UserAuth],
  components: {
    'standard-dialog': Dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: false,
      errors: [],
      authCode: null,
      authCodeRules: [v => (v && v.match(/^[0-9A-Za-z]{6}$/)) ? true : this.$t('gateway.six_chars_required')],
      loading: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    authCode(val) {
      this.errors = [];
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let code = this.authCode.toUpperCase();
        let ref = this.$db.ref('userAuth').child(this.userId);
        await ref.remove();
        await ref.set(code);
        ref.on('value', snapshot => {
          let val = snapshot.val();
          if (val) {
            if (val === 'invalid') {
              this.loading = false;
              this.errors = [this.$t('gateway.invalid_code', {
                code: code
              })];
              snapshot.ref.remove();
              snapshot.ref.off();
            } else if (val.length == 12) {
              snapshot.ref.remove();
              snapshot.ref.off();
              this.$emit('done', val);
            }
          }
        });
        setTimeout(() => {
          ref.off();
          this.loading = false;
        }, 5000);
      }
    }
  },
  mounted() {
    this.$refs.form.reset();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gateway/GatewayAuthCode.vue